import { escapeHtml } from 'framework/script_utilities/text-utils';

export class EscapeHTMLValueConverter {
  toView(value: string) {
    return value == null ? value : escapeHtml(value);
  }
}
